import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import bankServices from '@src/services/banks.services';

export const bankImageGetPagedList = createAsyncThunk(
  'admin/bankImageGetPagedList',
  async ({ pageNumber, pageSize }, { rejectWithValue }) => {
    try {
      const result = await bankServices.getBankImageList({ pageNumber, pageSize });
      return result;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const updateBank = createAsyncThunk(
  'admin/updateBank',
  async (data, { rejectWithValue }) => {
    try {
      return await bankServices.updateBank(data);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const deleteBank = createAsyncThunk(
  'admin/deleteBank',
  async (data, { rejectWithValue }) => {
    try {
      const response = await bankServices.deleteBank(data);
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const addNewBank = createAsyncThunk(
  'admin/addNewBank',
  async (data, { rejectWithValue }) => {
    try {
      return await bankServices.addNewBank(data);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  bankList: [],
  editData: {},
  tableProperty: {
    currentPage: 1,
    page: 1,
    pageSize: 10,
    totalCount: 0,
  },
};

export const managementBankSlice = createSlice({
  name: 'managementBank',
  initialState,
  reducers: {
    setEditData: (state, action) => {
      state.editData = action.payload;
    },
    resetEditData: (state, action) => {
      state.editData = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(bankImageGetPagedList.fulfilled, (state, action) => {
      state.bankList = action?.payload?.data?.items || [];
      state.tableProperty = action?.payload?.data?.pagedProperty || initialState?.tableProperty;
    });
    builder.addCase(bankImageGetPagedList.rejected, (state, action) => {
      state.bankList = [];
      state.tableProperty = {
        currentPage: 1,
        page: 1,
        pageSize: 10,
        totalCount: 0,
      };
    });
  },
});

export const { setEditData, resetEditData } = managementBankSlice.actions;
